var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CustomButton from '../../Shared/CustomButton/CustomButton';
import './CaenDocuments.scss';
var CaenDocuments = function (props) {
    var documents = props.documents;
    return (_jsxs("div", __assign({ className: 'caen-documents' }, { children: [_jsx("h3", __assign({ className: 'caen-documents__heading' }, { children: "Acte necesare pentru \u00EEnfiin\u021Bare" })), documents.map(function (document, index) { return (_jsx(CustomButton, __assign({ disabled: true }, { children: document.Name }), index)); })] })));
};
export default CaenDocuments;
